/**
 * 大包进度下钻抽屉标题：与 {@link BigBagProgressDrilldownDrawer} 中 i18n key
 * `wms.progress.bigBag.drilldown.titles.<value>` 一一对应。
 */
export const BigBagDrilldownTitleSource = {
  /** 指标卡「大包总差异率」区域点击差异数（未入库、有提单号口径） */
  KpiBagDiffNotInbound: 'kpiBagDiffNotInbound',
  /** 指标卡「大包总差异率」区域点击入库数（已入库、有提单号口径） */
  KpiBagInbound: 'kpiBagInbound',
  /** 指标卡「包裹总差异率」区域点击差异数（未入库） */
  KpiParcelDiffNotInbound: 'kpiParcelDiffNotInbound',
  /** 一级客户表「差异包裹数」（未入库、合并 bagType） */
  CustomerParcelDiffNotInbound: 'customerParcelDiffNotInbound',
  /** 二级「有提单号」提单行「差异包裹数」 */
  MawbSummaryParcelDiffNotInbound: 'mawbSummaryParcelDiffNotInbound',
  /** 三级 MAWB 下某大包「差异包裹数」 */
  MawbBagParcelDiffNotInbound: 'mawbBagParcelDiffNotInbound',
  /** 「无提单号」区点击大包号 → 大包明细 */
  NoMawbBagDetail: 'noMawbBagDetail',
  /** 「无提单号」行点击差异包裹数 */
  NoMawbParcelDiffNotInbound: 'noMawbParcelDiffNotInbound',
  /** 三级 MAWB 下点击大包号，且该大包已入库 */
  MawbBagDetailInbound: 'mawbBagDetailInbound',
  /** 三级 MAWB 下点击大包号，且该大包未入库 */
  MawbBagDetailNotInbound: 'mawbBagDetailNotInbound',
} as const;

export type BigBagDrilldownTitleSource =
  (typeof BigBagDrilldownTitleSource)[keyof typeof BigBagDrilldownTitleSource];
